<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center two-factor-page">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 login-max-w sm:m-0 m-4">

      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-stretch">

            <div class="vx-col hidden lg:flex lg:w-1/2 px-4 py-5 color-bg-login two-factor-page__aside">
              <img class="two-factor-page__brand" src="@/assets/images/logo/logo-full.svg" alt="Verificamex">
              <img class="two-factor-page__illustration" src="@/assets/images/pages/login.svg" alt="">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg flex items-center">
              <div class="p-8 login-tabs-container py-login w-full">

                <img class="block lg:hidden mb-6 max-w-logo mx-auto" src="@/assets/images/logo/logo-full.svg" alt="Verificamex">

                <div class="mb-6">
                  <h2 class="two-factor-page__title">{{ title }}</h2>
                  <p class="two-factor-page__subtitle">{{ subtitle }}</p>
                </div>

                <slot></slot>

                <p class="two-factor-page__back mt-6 text-center">
                  <router-link to="/login">Volver a iniciar sesión</router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
// Marco de las pantallas del doble factor durante el login: la misma tarjeta que Login.vue.
export default {
  name: 'TwoFactorLayout',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_colorsVariables.scss';

/* WHY: sin scoped, prefijado con .two-factor-page, porque el contenido del <slot> se
   compila en el componente padre y los estilos scoped de aquí no le llegarían. */
.two-factor-page {
  .two-factor-page__aside {
    position: relative !important;
    min-height: 500px;
  }
  .two-factor-page__brand {
    position: absolute;
    top: 32px;
    left: 50%;
    transform: translateX(-50%);
    max-width: 200px;
    width: auto;
    z-index: 1;
  }
  .two-factor-page__illustration {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 86%;
    max-width: 560px;
    height: auto;
  }
  .two-factor-page__title {
    font-size: 1.6rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 6px;
    line-height: 1.2;
  }
  .two-factor-page__subtitle {
    font-size: 0.95rem;
    color: rgba(0, 0, 0, 0.55);
    line-height: 1.5;
    margin: 0;
  }
  .two-factor-page__back {
    font-size: 0.9rem;

    a {
      color: $primary;
      font-weight: 500;
      text-decoration: none;

      &:hover { text-decoration: underline; }
    }
  }
}
</style>
